module.exports = __webpack_public_path__ + "static/media/compress-arrows-alt.b672d174.svg";